import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { formatValue } from '@ts-core/utils/dataTableUtils';

import makeStyles from '@mui/styles/makeStyles';

import Popover from '@mui/material/Popover';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import baseStyles from '@ts-core/styles/baseStyles';

const useStyles = makeStyles((theme) => ({
  ...baseStyles(theme),
  questionPopover: {
    pointerEvents: 'none',
  },
  questionPopoverContent: {
    padding: theme.spacing(2),
  },
}));

const QuestionStatsPopover = (props) => {
  const classes = useStyles();

  const { questionData, anchorEl, onClose } = props;

  if (!questionData) return null;
  const { answerTypes } = questionData;
  return (
    <Popover
      id="question"
      open={Boolean(anchorEl)}
      disableRestoreFocus
      className={classes.questionPopover}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      onMouseLeave={onClose}
      onClose={onClose}
    >
      {questionData && (
        <div className={classes.questionPopoverContent}>
          <Typography variant="subtitle2">{questionData.title}</Typography>
          <br />
          <Divider style={{ marginBottom: 8 }} />
          <Typography variant="body1" align="center">
            <FormattedMessage
              id="numberOfAnswers"
              values={{ value: questionData.answersCount || 0 }}
            />
          </Typography>
          {questionData.answersCount > 0 && (
            <Grid container spacing={2} style={{ width: 320 }}>
              <Grid item xs={4}>
                <Typography
                  align="center"
                  variant="h3"
                  component="p"
                  className={classes.optionPositive}
                >
                  {formatValue(answerTypes.positive, questionData.answersCount)}
                </Typography>
                <Typography align="center" className={classes.optionPositive}>
                  <FormattedMessage id="positives" />
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  align="center"
                  variant="h3"
                  component="p"
                  className={classes.optionNeutral}
                >
                  {formatValue(answerTypes.neutral, questionData.answersCount)}
                </Typography>
                <Typography align="center" className={classes.optionNeutral}>
                  <FormattedMessage id="neutrals" />
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  align="center"
                  variant="h3"
                  component="p"
                  className={classes.optionNegative}
                >
                  {formatValue(answerTypes.negative, questionData.answersCount)}
                </Typography>
                <Typography align="center" className={classes.optionNegative}>
                  <FormattedMessage id="negatives" />
                </Typography>
              </Grid>
            </Grid>
          )}
          <Divider style={{ marginTop: 8 }} />
        </div>
      )}
    </Popover>
  );
};

QuestionStatsPopover.propTypes = {
  questionData: PropTypes.object,
  anchorEl: PropTypes.object,

  onClose: PropTypes.func.isRequired,
};

QuestionStatsPopover.defaultProps = {
  questionData: {},
  anchorEl: undefined,
};

export default QuestionStatsPopover;
